import NormalTable from "../NormalTable";

export const selectedTopicRoute = [
    {
        path:"/view/sysManagement/business/:key",//选题管理
        component:NormalTable
    },
]